import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { Observable } from 'rxjs';
import { GetSelectedMealsRequestBody, MealCard, SaveSelectedMealsRequestBody, SelectedMealsResponse } from '../Models/selected-meal';

@Injectable({
  providedIn: 'root'
})
export class MealSelectionService {
  OBPortalSvcURL = '';
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private httpClient: HttpClient, private appConfigService: AppConfigService) {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
  }

  getSelectedMealsForGuests(mcdfoluids?: number[], shpId?: number, ilcDate?: string): Observable<SelectedMealsResponse> {
    const guests = new GetSelectedMealsRequestBody(mcdfoluids, shpId, ilcDate);

    return this.httpClient.post<SelectedMealsResponse>(`${this.OBPortalSvcURL}GetSelectedMeals`, guests, { headers: this.headers });
  }

  saveSelectedMealsForGuests(mealCards?: MealCard[]): Observable<SelectedMealsResponse> {
    const mealCardsBody = new SaveSelectedMealsRequestBody(mealCards);

    return this.httpClient.post<SelectedMealsResponse>(`${this.OBPortalSvcURL}SetSelectedMeals`, mealCardsBody, { headers: this.headers });
  }
}
